import { render } from "./OrgUnitRating.vue?vue&type=template&id=c6c01d9a&scoped=true"
import script from "./OrgUnitRating.vue?vue&type=script&lang=js"
export * from "./OrgUnitRating.vue?vue&type=script&lang=js"

import "./OrgUnitRating.vue?vue&type=style&index=0&id=c6c01d9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c01d9a"]])

export default __exports__